import {ANALYTICS_SOURCE_TYPES} from '@/services/analytics/constants';

function formatPrice(price) {
  // Handle null/undefined/empty
  if (price == null || price === '') {
    return '0';
  }

  // Convert to string and strip currency symbols/commas
  const priceStr = String(price);
  const cleaned = priceStr.replaceAll(/[^0-9.-]+/g, '');

  // Validate it's a proper number
  const parsed = Number.parseFloat(cleaned);
  if (Number.isNaN(parsed)) {
    return '0';
  }

  // Return absolute value as string (no negative prices)
  return Math.abs(parsed).toString();
}

function fromEbookSearchResultItem(ebook, options) {
  if (!ebook || typeof ebook !== 'object' || Array.isArray(ebook)) {
    console.warn('Invalid ebook data for product view:', ebook);
    return {items: []};
  }

  const productInfo = {
    sku: ebook.sku?.toString(),
    name: ebook.title,
    currency: options.currency,
    price: formatPrice(ebook.price),
  };
  const items = [{productInfo, tabTitle: 'NONE'}];

  return {items};
}

export const mapProductViewEvent = (source, options = {}) => {
  if (options.sourceType === ANALYTICS_SOURCE_TYPES.EBOOK_SEARCH_RESULT_ITEM) {
    return fromEbookSearchResultItem(source, options);
  }

  return source;
};
